import React, { useEffect, useState } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import AuditActions from "../../Actions/AuditActions";
import auditStore from "../../Stores/AuditStores";
import AuditConstants from "../../Constants/AuditConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
function AuditFieldLog(props) {
  const { fieldLogInfo } = props;
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [logFieldList, setLogFieldList] = useState([]);

  useEffect(() => {
    if (fieldLogInfo !== "") {
      AuditActions.getFieldLog(
        fieldLogInfo.auditObjectLogId,
        fieldLogInfo.fieldId
      );
    }
  }, [fieldLogInfo]);

  useEffect(() => {
    function getAuditLogFieldSuccess() {
      var res = auditStore.getAuditFieldLog();
      if (res.length > 0) {
        setLogFieldList(res);
        setGlobalSpinner(false);
      } else {
        setLogFieldList([]);
        setGlobalSpinner(false);
      }
    }

    function getAuditLogFieldFailure() {
      setGlobalSpinner(false);
    }

    auditStore.addChangeListener(
      AuditConstants.GET_AUDIT_FIELD_LOG_SUCCESS,
      getAuditLogFieldSuccess
    );

    auditStore.addChangeListener(
      AuditConstants.GET_OPERATION_AUDIT_LOG_FAILURE,
      getAuditLogFieldFailure
    );
    return () => {
      auditStore.removeChangeListener(
        AuditConstants.GET_AUDIT_FIELD_LOG_SUCCESS,
        getAuditLogFieldSuccess
      );

      auditStore.removeChangeListener(
        AuditConstants.GET_OPERATION_AUDIT_LOG_FAILURE,
        getAuditLogFieldFailure
      );
    };
  }, []);

  return (
    <>
      <div
        className="modal fade"
        id="auditFieldLog"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="auditFieldLog"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div
          className="modal-dialog d-flex  justify-content-center"
          role="document"
        >
          <div className="modal-content timeLineModel">
            <div className="modal-header">
              <div className="container">
                <div className="row d-flex">
                  <div className="col">
                    <h5 id="auditFieldLog">
                      {`${fieldLogInfo.fieldName} :- ${localization.fieldLog}`}
                    </h5>
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="auditFieldLogcloseModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body auditLogbody">
              {logFieldList.length > 0 && (
                <VerticalTimeline layout={"1-column-left"}>
                  {logFieldList.map((item, i) => {
                    return (
                      <VerticalTimelineElement
                        className="vertical-timeline-element--work "
                        contentArrowStyle={{
                          borderRight: "7px solid  black",
                        }}
                        date={item.updatedOn}
                        key={i}
                      >
                        <h3 className="vertical-timeline-element-title">
                          {item.operation}
                        </h3>
                        <h3 className="vertical-timeline-element-subtitle">
                          {localization.value}:{item.newValue}
                        </h3>
                        <h3>
                          {localization.performedBy} : {item.user}
                        </h3>
                      </VerticalTimelineElement>
                    );
                  })}
                </VerticalTimeline>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default AuditFieldLog;
